import { createBrowserRouter } from "react-router";
import Home from "./pages/Home";
import About from "./pages/About";
import YesProgram from "./pages/YesProgram";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ForTheRestOfUsWrapper from "./pages/ForTheRestOfUsWrapper";
import Join from "./pages/Join";
import Labs from "./pages/Labs";
import NotFound from "./pages/NotFound";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Home,
  },
  {
    path: "/about",
    Component: About,
  },
  {
    path: "/yes-program",
    Component: YesProgram,
  },
  {
    path: "/join",
    Component: Join,
  },
  {
    path: "/labs",
    Component: Labs,
  },
  {
    path: "/for-the-rest-of-us",
    Component: ForTheRestOfUsWrapper,
  },
  {
    path: "/blog",
    Component: Blog,
  },
  {
    path: "/blog/:id",
    Component: BlogPost,
  },
  {
    path: "*",
    Component: NotFound,
  },
]);